import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export interface MountPointConnection {
  mountPointId?: number;
  userId: string;
  mountPoint: string;
  server: string;
  port: string;
  downloaderUserName: string;
  downloaderPassword: string;
}

export interface PagedResult<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class MountpointConnectionService {
  private base = `${environment.apiBaseUrl}/mountpoint/connections`;
  constructor(private http: HttpClient, private auth: AuthService) {}

  list(search: string, page: number, size: number): Observable<PagedResult<MountPointConnection>> {
    let params = new HttpParams().set('page', String(page)).set('size', String(size));
    if (search && search.trim()) params = params.set('search', search.trim());
    return this.http.get<PagedResult<MountPointConnection>>(this.base, { params });
  }

  get(id: number): Observable<MountPointConnection> {
    return this.http.get<MountPointConnection>(`${this.base}/${id}`);
    }

  create(req: MountPointConnection): Observable<MountPointConnection> {
    return this.http.post<MountPointConnection>(this.base, req);
  }

  update(req: MountPointConnection): Observable<MountPointConnection> {
    return this.http.put<MountPointConnection>(`${this.base}/${req.mountPointId}`, req);
  }

  delete(ids: number[]): Observable<{ deleted: number }> {
    const params = new HttpParams().set('ids', ids.join(','));
    // Try DELETE with query params first; fallback to POST /delete (some envs block DELETE+params)
    return new Observable(sub => {
      this.http.delete<{ deleted: number }>(this.base, { params }).subscribe({
        next: v => { sub.next(v); sub.complete(); },
        error: _ => {
          this.http.post<{ deleted: number }>(`${this.base}/delete`, { ids }).subscribe({
            next: v2 => { sub.next(v2); sub.complete(); },
            error: err2 => sub.error(err2)
          });
        }
      });
    });
  }

  getCurrentUserId(): Observable<string> {
    try {
      const token = this.auth.getAccessToken();
      const payload = token ? JSON.parse(atob(token.split('.')[1])) : null;
      const sub = payload?.sub ?? '';
      return of(sub);
    } catch {
      return of('');
    }
  }
}


